import React from "react";
import PropTypes from "prop-types";

import InputField from "components/Input";
import Button from "components/Button";
import "./index.scss";

const VerifyEmail = ({
  formValues,
  handleVerifyEmail = () => {},
  isSubmitting,
}) => {
  return (
    <>
      <div className="verify-email">
        <div className="details">
          <InputField
            label="Email Address"
            name="emailAddress"
            field={{ readOnly: true }}
            value={formValues?.email}
          />
        </div>
        <div className="action">
          {!formValues?.email_verified && (
            <Button
              color="green"
              type="solid"
              onClick={(e) => handleVerifyEmail(e)}
              label="Verify Email Address"
              disabled={isSubmitting}
              loading={isSubmitting}
            />
          )}
        </div>
      </div>
    </>
  );
};

VerifyEmail.propTypes = {
  formValues: PropTypes.oneOfType([PropTypes.object]).isRequired,
  handleVerifyEmail: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default VerifyEmail;
